var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 53,
    viewBox: "0 0 38 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2297 1.56698C24.3246 1.23961 24.7707 1.19642 24.9267 1.49952L37.7125 26.3543C37.8426 26.6071 37.7866 26.9157 37.5761 27.1067L10.4066 51.7627C10.1253 52.018 9.6857 51.7437 9.79147 51.3788L24.2297 1.56698Z",
    fill: "#A37C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8088 1.56698C14.9037 1.23961 15.3498 1.19642 15.5058 1.49952L28.2916 26.3543C28.4217 26.6071 28.3657 26.9157 28.1552 27.1067L0.985713 51.7627C0.704362 52.018 0.264798 51.7437 0.370569 51.3788L14.8088 1.56698Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/UPI.c6ad4f5fd9d6ccc8ceda6412ba7544bf.svg";
export { ForwardRef as ReactComponent };